export default {
  name: 'ConfigMixin',
  computed: {
    appConfig () {
      return this.getConfig()
    }
  },
  methods: {
    getConfig () {
      return this.$store.getters.appConfig
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/configMixin.js